<template>
  <div class="card">
    <div class="card-header">
      <div class="row">
        <div class="col-md-10">
          <strong class="card-title mb-3">{{ 'Stock History' }}</strong>
        </div>
        <!-- <div class="col-md-2">
          <download :tableId="'stock-history'" :fileName="'stock-history'" fromExtFile="true"
            :downloadParam="collectedParam"></download>
        </div> -->
      </div>
    </div>

    <vue-tabs v-model="selTab" direction="horizontal" @tab-change="getTabData" class="mt-3 ml-3">
      <!-- TAB-1 -->
      <v-tab :title="'Stock History'">
        <div class="col-md-12">
          <download :tableId="'stock-history'" :fileName="'stock-history'" fromExtFile="true"
            :downloadParam="collectedParam"></download>
        </div>
        <div v-if="selTab === 'Stock History'" class="card-body">
          <div class="row">
            <div class="col-md-5">
              <div class="form-group">
                <v-select :options="companyList" :placeholder="'Select Company'" :label="'companyname'"
                  v-model="selComp" @input="getCompRawData">
                </v-select>
                <!-- <input type="text" v-model="searchParams.companyname" class="form-control" name="companyname"
                  placeholder="Search by Company" @keyup="search"> -->
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <select class="form-control" name="sector" v-model="searchParams.sectorname">
                  <option value>Select Sector</option>
                  <option v-for="(sec, index) in sectorData" :value="sec.sect_name" v-bind:key="sec.sect_code + index">
                    {{ sec.sect_name }}</option>
                </select>
              </div>
            </div>
            <div class="col-md-2">
              <div class="form-group">
                <v-select :options="durDateList" :placeholder="'Select Date'" v-model="ddate"
                  @input="getSelDate($event)"></v-select>
              </div>
            </div>
            <div class="col-md-2">
              <div class="row">
                <div class="form-group" style="margin-top: 3px;">
                  <button type="button" class="btn btn-sm btn-primary mr-2" @click="search">
                    <i class="fa fa-search"></i>
                  </button>
                  <button type="reset" class="btn btn-danger btn-sm" @click="reset">
                    <i class="fa fa-ban"></i> Reset
                  </button>
                </div>
              </div>
            </div>

          </div>
          <div class="table-responsive">
            <div class="table-responsive app">
              <table id="stock-history" class="table table-sm first-td-padding table-bordered app-inner">
                <thead>
                  <tr>
                    <th style="vertical-align:middle;">Sr.</th>
                    <th style="vertical-align:middle;" v-for="field in tableFields" v-bind:key="'field' + field.title">
                      {{ field.title }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, index) in fillableData" v-bind:key="'row' + index">
                    <td>{{ index + 1 }}</td>
                    <td style="width: 50%;">
                      <div class="company-wrapper">
                        <div class="comapny-child1">
                          <b>Company: </b><span>{{ row.companyname }}</span>
                        </div>
                        <div class="comapny-child1">
                          <b>ISIN: </b><span>{{ row.isin }}</span>
                        </div>
                        <div class="comapny-child1">
                          <b>Sector Name: </b><span>{{ row.sectorname }}</span>
                        </div>
                        <div class="comapny-child1">
                          <b>Co Code: </b><span>{{ row.co_code }}</span>
                        </div>
                        <div class="comapny-child1">
                          <b>Query Question: </b><span>{{ row.query_question }}</span>
                        </div>
                        <div class="comapny-child1">
                          <b>Created At: </b><span>{{ row.created_at }}</span>
                        </div>
                        <div class="comapny-child2 history-col">
                          <b>History: </b><span>{{ row.history }}</span>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div>
                        <vue-ckeditor :id="`history-ck${index}`" v-model="fillableData[index].analytics_history"
                          :config="config" />
                      </div>
                      <div style="display: flex;justify-content: flex-end;margin-top: 8px;">
                        <button type="button" @click="saveHistory(index)" class="btn btn-sm mb5 btn-primary"
                          style="padding: 0.2rem;">Save</button>
                      </div>
                    </td>
                  </tr>
                </tbody>
                <tfoot v-if="fillableData.length == 0">
                  <tr>
                    <td :colspan="(tableFields.length)">
                      <i class="fa fa-info cwhite"></i> No data found.
                    </td>
                  </tr>
                </tfoot>
              </table>
              <div class="pull-right" v-if="searchParams.sectorname == '' && searchParams.companyname == ''">
                <ul v-if="this.totalPages != 1" class="pagination">
                  <li :class="{ disabled: prevDisabled }" class="page-item">
                    <a class="page-link" @click.prevent="goToPage(1)" href="#">{{ '&lt;&lt;' }}</a>
                  </li>
                  <li :class="{ disabled: prevDisabled }" class="page-item">
                    <a class="page-link" @click.prevent="prev()" href="#">{{ '&lt;' }}</a>
                  </li>
                  <li v-for="page in pages" v-bind:key="page" class="page-item"
                    :class="(current_page == page) ? 'active' : ''">
                    <a class="page-link" @click.prevent="goToPage(page)" href="#">{{ page }}</a>
                  </li>
                  <li :class="{ disabled: nextDisabled }" class="page-item">
                    <a class="page-link" href="#" @click.prevent="next()">{{ '&gt;' }}</a>
                  </li>
                  <li :class="{ disabled: nextDisabled }" class="page-item">
                    <a class="page-link" href="#" @click.prevent="goToPage(totalPages)">{{ '&gt;&gt;' }}</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <PinCheck :show.sync="show" ref="smallModal" v-bind:small="true" @submitForm="submitForm"
          :cancelClass="'btn btn-secondary'"></PinCheck>
      </v-tab>
      <!-- TAB-1 -->
      <!-- TAB-2 -->
      <v-tab :title="'Stock Query'">
        <div class="mb-5" v-if="selTab === 'Stock Query'">
          <div style="margin-top: 20px; margin-left: 5px;">
            <div class="col-md-6">
              <div class="form-group">
                <v-select :options="companyList" :placeholder="'Select Company'" :label="'companyname'"
                  v-model="selComp" @input="getCompRawData">
                </v-select>
              </div>
            </div>
          </div>
          <form class="form-horizontal" style="margin-left: 5px;">
            <div class="form-group row" style="display: contents;">
              <label for="stock-query-txt" class="col-sm-2 col-form-label">Stock Query</label>
              <div class="col-sm-12">
                <textarea name="textarea-input" v-model="newQueryData.query_question" id="stock-query-txt" rows="6"
                  placeholder="" class="form-control"></textarea>
              </div>
            </div>
          </form>
          <div style="display: flex;justify-content: center;margin-top: 8px;">
            <button type="button" @click="stockQuerySubmit" class="btn btn-sm mb5 btn-primary"
              style="padding: 0.2rem;">Submit</button>
          </div>
        </div>
      </v-tab>
      <!-- TAB-2 -->
      <!-- TAB-3 -->
      <v-tab :title="'Cron Query'">
        <div class="mb-5" v-if="selTab === 'Cron Query'">
          <form class="form-horizontal" style="margin-left: 5px;">

            <div style="display: flex;justify-content: center;margin-top: 8px;">
              <button type="button" @click="showNewQuery" class="btn btn-sm mb5 btn-primary"
                style="padding: 0.2rem;">New Query</button>
            </div>
            <div v-if="isShow" class="d-flex flex-row border p-2 mb-4" style="background-color: #abe5f0;">
              <label for="stock-query-txt" class="col-form-label mr-2">{{ isNew ? "New:" : "Edit:" }}</label>
              <textarea v-model="editCronQueryData.query_question" name="textarea-input" id="stock-query-txt" rows="3"
                placeholder="" class="form-control col-sm-10"></textarea>
              <div class="d-flex align-items-center mr-3 ml-2">
                <label for="is-used" class="m-0">Is Used: <input type="checkbox" v-model="editCronQueryData.is_used"
                    name="is-used" style="width: auto;"></label>
              </div>
              <div class="d-flex align-items-center mr-3">
                <button type="button" @click="cronQuerySubmit" class="btn btn-sm mb5 btn-primary"
                  style="padding: 0.2rem;">Submit</button>
              </div>
            </div>
            <hr style="height:2px;border-width:0;color:gray;background-color:gray" />
            <div class="form-group row cron-query-content">
              <!-- <label for="stock-query-txt" class="col-sm-2 col-form-label">Cron Query</label> -->
              <br />
              <div class="d-flex flex-row border p-2 mb-4" v-for="(field, index) in cronQueryDataList"
                style="background-color: #e3e9ac;">
                <textarea :key="`cmp${index}`" name="textarea-input" v-model="field.query_question" rows="3"
                  placeholder="" class="form-control col-sm-10" style="background-color: #ffffff;" readonly></textarea>
                <div class="d-flex align-items-center mr-3 ml-2">
                  <label v-if="field.is_used" for="current-used" class="m-0">Current Used: <input type="radio" readonly
                      :checked="field.is_used" name="current-used" style="width: auto;"></label>
                </div>
                <div class="d-flex align-items-center mr-3">
                  <a class="btn btn-sm btn-small btn-primary" @click.prevent="editQuery(field)">
                    <i :title="'Edit'" class="fa fa-edit cwhite"></i>
                  </a>
                  <a style="margin:1px 4px" class="btn btn-sm btn-small btn-danger" v-bind:key="'delete'"
                    @click.prevent="deleteCronQueryHandler(field._id)">
                    <i :title="'Delete'" class="fa" :class="'fa-remove cwhite'"></i>
                  </a>
                </div>
              </div>
            </div>
          </form>
        </div>
      </v-tab>
      <!-- TAB-3 -->
      <!-- Sector Query -->
      <v-tab :title="'Sector Query'">
        <div class="mb-5" v-if="selTab === 'Sector Query'">
          <form class="form-horizontal" style="margin-left: 5px;">
            <div class="col-md-3">
              <div class="form-group mt-3" style="margin-bottom: 0.25rem">
                <select class="form-control" name="sector" v-model="searchParams.sectorname"
                  @change="sectorChangeHandler($event)">
                  <option value>All Sectors</option>
                  <option v-for="(sec, index) in sectorData" :value="sec.sect_name" :data="sec.sect_code"
                    v-bind:key="sec.sect_code + index">
                    {{ sec.sect_name }}</option>
                </select>
              </div>
            </div>
            <div v-if="newSectorQueryShow">
              <div v-if="allList === false" style="display: flex;justify-content: center;margin-top: 8px;">
                <button type="button" @click="showNewQueryForSector" class="btn btn-sm mb5 btn-primary"
                  style="padding: 0.2rem;">New Query</button>
              </div>
              <div v-if="isShow" class="border" style="background-color: #abe5f0; margin: 0px 10px 0px 0px;">
                <div style="text-align: center;">
                  <!-- <div v-if="isShow">{{ isNew ? "New:" : "Edit:" }}</div> -->
                  <!-- <span v-if="isShow" class="text-bold">{{ isNew ? "New:" : "Edit:" }}</span> -->
                  <span class="col-form-label mr-2 n-lbl">
                    <span class="text-bold">Sector Name: </span>{{ editSectorQueryData.sector_name }}
                  </span>
                  <span class="col-form-label mr-2 n-lbl">
                    <span class="text-bold">Sector Code: </span>{{ editSectorQueryData.sector_code }}
                  </span>
                </div>
                <div class="row d-flex flex-row m-0">
                  <div class="col-md-4">
                    <label for="stock-query-txt" class="col-form-label mr-2 p-1">Common Query</label>
                    <textarea v-model="editSectorQueryData.common_query" name="textarea-input" id="stock-query-txt"
                      rows="6" placeholder="" class="form-control text-small"></textarea>
                  </div>
                  <div class="col-md-4">
                    <label for="stock-query-txt" class="col-form-label mr-2 p-1">Sector Query</label>
                    <textarea v-model="editSectorQueryData.sector_query" name="textarea-input" id="stock-query-txt"
                      rows="6" placeholder="" class="form-control text-small"></textarea>
                  </div>
                  <div class="col-md-4">
                    <label for="stock-query-txt" class="col-form-label mr-2 p-1">Main Query</label>
                    <textarea v-model="editSectorQueryData.final_query" name="textarea-input" id="stock-query-txt"
                      rows="6" placeholder="" class="form-control text-small" disabled></textarea>
                  </div>
                  <div class="d-flex align-items-center justify-content-center ml-2 mt-2 w-100">
                    <button type="button" @click="sectorQuerySubmit" class="btn btn-sm mb5 btn-primary"
                      style="padding: 0.2rem;">Submit</button>
                  </div>
                </div>
              </div>
            </div>
            <hr style="height:2px;border-width:0;color:gray;background-color:gray" />
            <div class="form-group row sector-query-content">
              <div class="w-100 text-center" v-if="newSectorQueryShow">
                <h5>SECTOR QUERY LIST</h5>
              </div>
              <br />
              <!-- <div class="border p-2 mb-4" v-for="(field, index) in sectorQueryDateList"
                style="background-color: #e3e9ac; margin: 0 12px;">
                <div style="text-align: center;">
                  <span class="col-form-label mr-2 n-lbl">
                    <span class="text-bold">Sector Name: </span>{{ field.sector_name }}
                  </span>
                  <span class="col-form-label mr-2 n-lbl">
                    <span class="text-bold">Sector Code: </span>{{ field.sector_code }}
                  </span>
                </div>
                <div class="row d-flex flex-row">
                  <div class="col-md-4">
                    <label for="stock-query-txt" class="col-form-label mr-2">Common Query</label>
                    <textarea :key="`cmp1${index}`" name="textarea-input" v-model="field.common_query" rows="8"
                      placeholder="" class="form-control" style="background-color: #ffffff;" readonly></textarea>
                  </div>
                  <div class="col-md-4">
                    <label for="stock-query-txt" class="col-form-label mr-2">Sector Query</label>
                    <textarea :key="`cmp2${index}`" name="textarea-input" v-model="field.sector_query" rows="8"
                      placeholder="" class="form-control" style="background-color: #ffffff;" readonly></textarea>
                  </div>
                  <div class="col-md-4">
                    <label for="stock-query-txt" class="col-form-label mr-2">Final Query</label>
                    <textarea :key="`cmp3${index}`" name="textarea-input" v-model="field.final_query" rows="8"
                      placeholder="" class="form-control" style="background-color: #ffffff;" readonly></textarea>
                  </div>
                  <div class="d-flex align-items-center justify-content-center w-100 mt-2">
                    <a class="btn btn-sm btn-small btn-primary" @click.prevent="editSectorQueryHandler(field)">
                      <i :title="'Edit'" class="fa fa-edit cwhite"></i>
                    </a>
                    <a style="margin:1px 4px" class="btn btn-sm btn-small btn-danger" v-bind:key="'delete'"
                      @click.prevent="deleteSectorQueryHandler(field._id)">
                      <i :title="'Delete'" class="fa" :class="'fa-remove cwhite'"></i>
                    </a>
                  </div>
                </div>
              </div> -->
              <!-- NEW TABLE -->
              <div class="card-body" style="padding-top: 0px;">
                <div class="row mb5">
                  <div class="col-md-10"></div>
                  <div class="col-md-2">
                    <!-- <router-link :to="'/portfolios/add'" class="btn btn-sm btn-success pull-right">
                      <i class="fa fa-plus"></i> Add Portfolio
                    </router-link> -->
                  </div>
                </div>
                <div class="table-responsive app" v-dragscroll="true">
                  <table id="users" class="table table-sm first-td-padding table-bordered app-inner"
                    style="font-size: small;">
                    <thead>
                      <tr>
                        <th class="align-middle">Sr.</th>
                        <th class="align-middle">Sector Name</th>
                        <th class="align-middle">Sector Code</th>
                        <th class="align-middle">Common Query</th>
                        <th class="align-middle">Sector Query</th>
                        <th class="align-middle">Final Query</th>
                        <th class="align-middle"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(field, index) in sectorQueryDateList" v-bind:key="'row' + index">
                        <td>{{ index + 1 }}</td>
                        <td>
                          <span>{{ field.sector_name }}</span>
                        </td>
                        <td>
                          <span>{{ field.sector_code }}</span>
                        </td>
                        <td>
                          <span>{{ field.common_query }}</span>
                        </td>
                        <td>
                          <span>{{ field.sector_query }}</span>
                        </td>
                        <td>
                          <span>{{ field.final_query }}</span>
                        </td>
                        <td>
                          <div class="d-flex align-items-center justify-content-center w-100 mt-2">
                            <a class="btn btn-sm btn-small btn-primary" @click.prevent="editSectorQueryHandler(field)">
                              <i :title="'Edit'" class="fa fa-edit cwhite"></i>
                            </a>
                            <a style="margin:1px 4px" class="btn btn-sm btn-small btn-danger" v-bind:key="'delete'"
                              @click.prevent="deleteSectorQueryHandler(field._id)">
                              <i :title="'Delete'" class="fa" :class="'fa-remove cwhite'"></i>
                            </a>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                    <!-- <tfoot v-if="fillableData.length == 0">
                      <tr>
                        <td :colspan="(tableFields.length + 1 + actions.length)">
                          <i class="fa fa-info cwhite"></i> No data found.
                        </td>
                      </tr>
                    </tfoot> -->
                  </table>
                </div>
              </div>
              <!-- NEW TABLE -->
            </div>
          </form>
        </div>
      </v-tab>
      <!-- Sector Query -->
    </vue-tabs>




  </div>
</template>

<script>
import vtable from "@/components/vtable";
import http from "@/lib/http";
import VueJwtDecode from 'vue-jwt-decode'
import VueCkeditor from "vue-ckeditor2";
import Datepicker from "vuejs-datepicker";
import moment from "moment";
import PinCheck from "@/components/PinCheck.vue";
import { commonMixins } from "../../assets/mixins/common.js";
import configURL from '@/lib/config';

export default {
  name: "stock-history",
  components: {
    vtable,
    VueCkeditor,
    Datepicker,
    PinCheck
  },
  mixins: [commonMixins],
  created() {
    console.log("Config ", process.env.API_URL);
    this.url = this.apiUrl;
    console.log(this.url.indexOf("stock-history"), this.$route.query);
    // if (this.url.indexOf("stock-history") != -1) this.url += this.pageToLoad;
    this.$route.query.page
      ? (this.pageToLoad = parseInt(this.$route.query.page))
      : (this.pageToLoad = "1");
    this.url += "/page/" + this.pageToLoad;
    this.current_page = this.pageToLoad;
    console.log("this.searchParams", this.searchParams);
    if (localStorage.getItem('secC')) {
      this.searchParams.sectorname = localStorage.getItem('secC');
    };
    this.getCompaniesList();
    this.fetchData(this.searchParams);
    this.getStockHistoryDate();
    //console.log('this.selTab >>>', this.selTab);
  },
  watch: {
    reload() {
      this.fillTable();
    },
    $route(to, from) {
      this.pageToLoad = to.query.page;
      console.log("watch route", to.query);
      // this.fetchData(to.query)
    }
  },
  data() {
    return {
      //apiUrl: "companiesListing/page/",
      apiUrl: "get/stock-history",
      apiMode: true,
      show: false,
      company: {},
      selTab: "",
      selComp: "",
      newSectorQueryShow: false,
      isShow: false,
      isNew: false,
      allList: false,
      companyList: [],
      cronQueryDataList: [],
      isFromStockQuery: false,
      /* actions: [
        {
          btnClass: "btn-success",
          icon: "fa-eye cwhite",
          callback: this.showDetailView,
          tooltip: "View Details"
        },
        {
          btnClass: "btn-warning",
          icon: "fa-calculator cwhite",
          callback: this.viewCalculatedData,
          tooltip: "Calculated Data"
        },
        {
          btnClass: "btn-primary",
          icon: "fa-edit cwhite",
          callback: this.editCompany,
          tooltip: "Edit"
        }
      ], */
      tableFields: [
        {
          name: "details",
          title: "Company Details"
        },
        {
          name: "edit_history",
          title: "Edit History"
        },
        /* {
          name: "companyname",
          title: "Company Name"
        },
        {
          name: "isin",
          title: "ISIN"
        },
        {
          name: "co_code",
          title: "Co Code"
        },
        {
          name: "sectorname",
          title: "Sector Name"
        },
        {
          name: "history",
          title: "History"
        } */
      ],
      // itemsPerPage: ItemsPerPageDef.itemsPerPage,
      // sortFunctions: FieldsDef.sortFunctions,
      collectedParam: "",
      selectedRowCompanyData: {},
      paginationPath: "",
      searchParams: { companyname: "", sectorname: "" },
      selectedSector: { sect_name: "", sect_code: "" },
      durDateList: [],
      sectorData: [],
      fillableData: [],
      sectorQueryDateList: [],
      url: "",
      current_page: 1,
      pageToLoad: 1,
      totalPages: 1,
      prevDisabled: 1,
      nextDisabled: 0,
      pages: [],
      newQueryData: { company_code: "", query_question: "" },
      editCronQueryData: { query_question: "", is_used: false },
      editSectorQueryData: { isEdit: false, common_query: "", sector_query: "", sector_name: "", sector_code: "" },
      config: {
        toolbar: [
          {
            name: "snddocument",
            items: [
              "Source",
              "-",
              "Save",
              "NewPage",
              "DocProps",
              "Preview",
              "Print",
              "-",
              "Templates"
            ]
          },
          { name: "clipboard", items: ["Undo", "Redo"] },
          {
            name: "editing",
            items: [
              "Find",
              "Replace",
              "-",
              "SelectAll",
              "-",
              "SpellChecker",
              "Scayt"
            ]
          },
          {
            name: "forms",
            items: [
              "Form",
              "Checkbox",
              "Radio",
              "TextField",
              "Textarea",
              "Select",
              "Button",
              "ImageButton",
              "HiddenField"
            ]
          },
          "/",
          {
            name: "basicstyles",
            items: [
              "Bold",
              "Italic",
              "Underline",
              "Strike",
              "Subscript",
              "Superscript",
              "-",
              "RemoveFormat"
            ]
          },
          {
            name: "paragraph",
            items: [
              "NumberedList",
              "BulletedList",
              "-",
              "Outdent",
              "Indent",
              "-",
              "Blockquote",
              "CreateDiv",
              "-",
              "JustifyLeft",
              "JustifyCenter",
              "JustifyRight",
              "JustifyBlock",
              "-",
              "BidiLtr",
              "BidiRtl"
            ]
          },
          { name: "links", items: ["Link", "Unlink", "Anchor"] },
          {
            name: "insert",
            items: [
              "Image",
              // "Flash",
              "Table",
              "HorizontalRule",
              "Smiley",
              "SpecialChar",
              "PageBreak",
              "Iframe"
            ]
          },
          { name: "styles", items: ["Styles", "Format", "FontSize"] },
          { name: "colors", items: ["TextColor", "BGColor"] },
          { name: "tools", items: ["Maximize", "ShowBlocks"] }
        ]
      },
      ddate: ""
    };
  },
  methods: {
    getTabData(tabIndex, newTab, oldTab) {
      this.selTab = newTab.title;
      console.log('TAB: ', tabIndex, newTab)
      if (tabIndex === 0) {
        this.editCronQueryData = { query_question: "", is_used: false };
        this.newQueryData = { company_code: "", query_question: "" };
        this.isNew = false;
        this.isShow = false;
        this.cronQueryDataList = [];
        this.getStockHistoryDate();
      } else if (tabIndex === 1) {
        this.editCronQueryData = { query_question: "", is_used: false };
        this.newQueryData = { company_code: "", query_question: "" };
        this.isNew = false;
        this.isShow = false;
        this.cronQueryDataList = [];
        this.isFromStockQuery = false;
      } else if (tabIndex === 2) {
        this.newQueryData = { company_code: "", query_question: "" };
        this.editCronQueryData = { query_question: "", is_used: false };
        this.isNew = false;
        this.isShow = false;
        this.isFromStockQuery = false;
        this.cronQueryDataList = [];
        this.getStockHistoryCronQuery();
      } else if (tabIndex === 3) {
        //sanjay
        this.editSectorQueryData = { isEdit: false, common_query: "", sector_query: "", sector_name: "", sector_code: "" };
        this.searchParams = { companyname: "", sectorname: "" };
        this.allList = true;
        this.newSectorQueryShow = false;
        this.isNew = false;
        this.isShow = false;
        this.getAllSectorQueryDate();
      }
    },
    sectorChangeHandler(e) {
      console.log('change :::', e, (e.target.selectedIndex - 1))
      if ((e.target.selectedIndex - 1) === -1) {
        this.allList = true;
        this.newSectorQueryShow = true;
        this.isNew = false;
        this.isShow = false;
        this.sectorQueryDateList = [];
        this.editSectorQueryData = { isEdit: false, common_query: "", sector_query: "", sector_name: "", sector_code: "" };
        this.getAllSectorQueryDate();
      } else {
        //const selectedValue = e.target.value;
        this.allList = false;
        this.newSectorQueryShow = true;
        this.selectedSector = this.sectorData[e.target.selectedIndex - 1];
        this.editSectorQueryData.sector_name = this.selectedSector.sect_name;
        this.editSectorQueryData.sector_code = this.selectedSector.sect_code;
        this.editSectorQueryData.isEdit = false;
        this.editSectorQueryData.common_query = "";
        this.editSectorQueryData.sector_query = "";
        console.log("selectedSector : ", this.selectedSector);
        this.isNew = false;
        this.isShow = false;
        this.getSectorQueryDate();
      }
    },
    getCompaniesList() {
      let _this = this;
      http.get("getCompanyMaster", {}, function (error, response) {
        var companyList = response;
        if (companyList.length > 0) {
          _this.companyList = _this.sorted_fields_asc(
            companyList,
            "companyname"
          );
          /* if (!localStorage.getItem("selcomp")) {
            _this.selComp = _this.companyList[0];
            localStorage.setItem("selcomp", JSON.stringify(_this.selComp));
          } else {
            _this.selComp = JSON.parse(localStorage.getItem("selcomp"));
          }
          console.log("Selected Comp", typeof _this.selComp);
          _this.company.companyname = _this.selComp.companyname;
          _this.company.co_code = _this.selComp.co_code; */
        }
      });
    },
    getCompRawData() {
      console.log('Selected Tab: ', this.selTab);
      console.log("Get RawData", this.selComp);
      if (this.selComp !== null) {
        this.newQueryData.company_code = this.selComp.co_code;
      } else {
        this.newQueryData.company_code = "";
      }

      if (this.selTab === "Stock History") {
        this.ddate = "";
        this.getStockHistoryDate(this.selComp);
      }
      /* if (this.selComp === "Stock Query") {
       
        //this.getRawData();
      } */
    },
    getStockHistoryCronQuery() {
      //https://api.nobiasinvesting.com/get/get_stock_history_cron_query_question
      let _this = this;
      http.get("get/get_stock_history_cron_query_question", {}, function (error, response) {
        if (response.status === "success") {
          _this.cronQueryDataList = response.data;
        }
      });
    },
    editQuery(param) {
      console.log('Cron Query : param >>>', param)
      this.editCronQueryData = param;
      this.isNew = false;
      this.isShow = true;
      console.log("editQuery param", param);
    },
    deleteCronQueryHandler(id) {
      console.log('Delete Cron Query : param >>>', id)
      /* this.isNew = false;
      this.isShow = true; */
      let _this = this;
      http.post("delete_stock_history_cron_query_question", { "_id": id }, function (error, response) {
        console.log('delete crone query response:', response)
        if (response.status === "success") {
          _this.$toastr.success(response.message, "", {});
          _this.getStockHistoryCronQuery();
        }
      });
    },
    showNewQuery() {
      this.editCronQueryData = { query_question: "", is_used: false };
      this.isNew = true;
      this.isShow = true;
    },
    showNewQueryForSector() {
      this.allList = false;
      this.editSectorQueryData = { isEdit: false, common_query: "", sector_query: "", sector_name: this.selectedSector.sect_name, sector_code: this.selectedSector.sect_code };
      //editSectorQueryData: { _id: "", common_query: "", sector_query: "", sector_name: "", sector_code: "" },
      this.isNew = true;
      this.isShow = true;
    },
    viewCalculatedData(row) {
      localStorage.setItem("selcomp", JSON.stringify({ companyname: row.companyname, co_code: row.co_code }));
      this.$router.push({ name: "calculateddata", params: { company: row } });
      //`rawdata/${row}`
    },
    viewRawData(row) {
      this.$router.push({ name: "rawdata", params: { company: row } });
      //`rawdata/${row}`
    },
    getSelDate(e) {
      console.log("Selected date", e);
      this.ddate = e;
      //this.getRawData();
    },
    saveHistory(e) {
      //console.log("save history: ", e);
      this.selectedRowCompanyData = this.fillableData[e];
      //console.log("Row Compnay Data: ", this.selectedRowCompanyData);
      //this.submitAnalyticsHistory();
      this.$refs.smallModal.open();
    },
    stockQuerySubmit() {
      //console.log('=> Stock Query Submit', this.newQueryData, this.selComp);
      console.log('=> Stock Query Submit', this.newQueryData, this.selComp);

      let _this = this;

      this.newQueryData.company_code = this.selComp.co_code;

      if (this.newQueryData.company_code.trim() === "") {
        this.$toastr.error("Please Select Company", "", {});
        return;
      }

      if (this.newQueryData.query_question.trim() === "") {
        this.$toastr.error("Query string not blank", "", {});
      } else {

        http.post("gemini/frontend/insertStockDetailsFromAi", this.newQueryData, function (error, response) {
          if (response.success === "success") {
            _this.isFromStockQuery = true;
            _this.$toastr.success(response.message, "", {});
            _this.selTab = "Stock History";

            _this.fetchData(_this.searchParams);
          }
        });
      }
    },
    cronQuerySubmit() {
      console.log('Cron Query Submit', this.editCronQueryData);
      let _this = this;
      if (this.editCronQueryData.query_question.trim() === "") {
        this.$toastr.error("Query string not blank", "", {});
      } else {
        http.post("update_or_create/stock_history_cron_query_question", this.editCronQueryData, function (error, response) {
          if (response.status === "success") {
            _this.$toastr.success(response.message, "", {});
            _this.getStockHistoryCronQuery();
            _this.editCronQueryData = { query_question: "", is_used: false };
            _this.isNew = false;
            _this.isShow = false;
          }
        });
      }
    },
    sectorQuerySubmit() {
      let _this = this;
      console.log('allList >>', this.allList)
      if (!this.allList) {
        this.editSectorQueryData.sector_name = this.selectedSector.sect_name;
        this.editSectorQueryData.sector_code = this.selectedSector.sect_code;
      }

      let param = { common_query: _this.editSectorQueryData.common_query, sector_query: _this.editSectorQueryData.sector_query, sector_name: _this.editSectorQueryData.sector_name, sector_code: _this.editSectorQueryData.sector_code };
      if (_this.editSectorQueryData.isEdit) {
        param._id = _this.editSectorQueryData._id;
      }

      console.log('editSectorQueryData Submit', param);

      if (param.common_query.trim() === "" || param.sector_query.trim() === "") {
        this.$toastr.error("Query string not blank", "", {});
      } else {
        //return;
        http.post("update_or_create/sector_query", param, function (error, response) {
          console.log('Create/Update: ', response);
          if (response.status === "success") {
            _this.$toastr.success(response.message, "", {});
            if (_this.allList) {
              _this.getAllSectorQueryDate();
            } else {
              _this.getSectorQueryDate();
            }
            //_this.sectorQueryDateList = { query_question: "", is_used: false };
            _this.isNew = false;
            _this.isShow = false;
          } else {
            _this.$toastr.error(response.message, "", {});
          }
        });
      }
    },
    deleteSectorQueryHandler(_id) {
      let _this = this;
      const param = { _id: _id };
      console.log('Delete param ', param);

      http.post("delete/sector_query", param, function (error, response) {
        console.log('Delete: ', response);
        if (response.status === "success") {
          _this.$toastr.success(response.message, "", {});
          _this.getSectorQueryDate();
          _this.isNew = false;
          _this.isShow = false;
        } else {
          _this.$toastr.error(response.message, "", {});
        }
      });
    },
    editSectorQueryHandler(param) {
      console.log("sector editQuery param", param, this.allList);

      //this.newSectorQueryShow = true;

      var newEditParam = Object.assign({}, param);
      console.log('newEditParam :::', newEditParam)
      newEditParam.isEdit = true;
      this.newSectorQueryShow = true;
      this.isShow = true;

      this.editSectorQueryData = newEditParam;
      this.isNew = false;
    },
    getSectorQueryDate() {
      console.log('==> TAB: ', this.selTab, this.selectedSector);
      let self = this;
      let apiUrl = "get/sector_query?sector_code=" + this.selectedSector.sect_code;

      http.get(apiUrl, {}, (error, response) => {
        if (response.status === "success") {
          self.sectorQueryDateList = response.data;
          console.log("sector response >>> ", self.sectorQueryDateList);
        }
      });
    },
    getAllSectorQueryDate() {

      let self = this;
      let apiUrl = "get/sector_query";

      http.get(apiUrl, {}, (error, response) => {
        if (response.status === "success") {
          self.sectorQueryDateList = response.data;
          console.log("sector response >>> ", self.sectorQueryDateList);
        }
      });
    },
    getStockHistoryDate(param) {
      console.log('==> TAB: ', this.selTab, param);
      let extDateParam = "";
      if (this.selTab === "Stock History") {
        if (param != undefined || param != null) {
          extDateParam = '&company_code=' + param.co_code;
        }
      }
      let apiUrl = "frontend/filter-date?collection_name=stock-history" + extDateParam;

      http.get(apiUrl, {}, (error, response) => {
        console.log("date response: ", response);
        if (response.responseType === 'success') {
          this.durDateList = response.date;
          /* this.durDateList.map((date, index) => {
            console.log("* ",date, date.split('T')[0])
            this.durDateList[index] = date.split('T')[0];
          }); */
        }
      });
    },
    submitForm() {
      // this.validatePin(pin);
      console.log("selectedRowCompanyData: ", this.selectedRowCompanyData);
      const data = {
        co_code: this.selectedRowCompanyData.co_code,
        comment: this.selectedRowCompanyData.analytics_history
      };
      console.log("submitpin entered ", data);

      //return;
      http.post("companyGeneralComments/update", data, (error, response) => {
        console.log("Response", response);
        if (response.responseType === "success") {
          this.$toastr.success("Updated Successfully!", "", {});
        } else {
          this.$toastr.error("Error", "", {});
        }
        this.submitAnalyticsHistory();
      });
    },
    submitAnalyticsHistory() {
      //console.log("submitAnalyticsHistory=> ", this.selectedRowCompanyData);
      http.post("update/stock-history", this.selectedRowCompanyData, (error, response) => {
        console.log("Response", response);
        if (response.status === "success") {
          this.$toastr.success("Updated Successfully!", "", {});
        } else {
          this.$toastr.error("Error", "", {});
        }
      });
    },
    search() {
      //console.log("search: ",this.searchParams, this.selComp.companyname);
      try {
        if (this.selComp.companyname != undefined || this.selComp.companyname != null) {
          this.searchParams.companyname = this.selComp.companyname;
        }
      } catch (error) {
        this.searchParams.companyname = "";
      }
      console.log('this.searchParams =>>>', this.searchParams);
      if (
        this.searchParams.companyname.length > 2 ||
        this.searchParams.sectorname != ""
      ) {
        if (this.searchParams.sectorname != "") {
          localStorage.setItem('secC', this.searchParams.sectorname);
        }
      }
      this.fetchData(this.searchParams);
      if (
        this.searchParams.companyname.length == 0 &&
        this.searchParams.sectorname == ""
      ) {
        console.log("Reset");
        //this.reset();
      } else {
        console.log("Not Reset");
      }
      let paramCompanyName = "";
      let paramSector = "";
      let paramSelDate = "";
      if (this.searchParams.companyname.length !== 0) {
        paramCompanyName = `&companyname=${this.searchParams.companyname}`;
      }
      if (this.searchParams.sectorname.length !== 0) {
        paramSector = `&sectorname=${this.searchParams.sectorname}`;
      }
      console.log('this.ddate=>>', this.ddate)
      if (this.ddate !== null && this.ddate !== "") {
        paramSelDate = `&selectdate=${this.ddate}`;

      }
      this.collectedParam = paramCompanyName + paramSector + paramSelDate;
    },
    getSectorData() {
      let _this = this;
      // this.axios.get("getSectorList", {}, {headers: {Authorization: 'Bearer ' + localStorage.getItem('token')}}).then((response) => {
      http.get("getSectorList", {}, function (error, response) {
        console.log("> Sector Data", response);
        _this.sectorData = response;
      });
      this.sectorData = [
        {
          "sect_name": "Agro Chemicals",
          "sect_code": "00000001"
        },
        {
          "sect_name": "Automobile",
          "sect_code": "00000005"
        },
        {
          "sect_name": "Banks",
          "sect_code": "00000006"
        },
        {
          "sect_name": "Cement",
          "sect_code": "00000011"
        },
        {
          "sect_name": "Cement - Products",
          "sect_code": "00000012"
        },
        {
          "sect_name": "Ceramic Products",
          "sect_code": "00000013"
        },
        {
          "sect_name": "Chemicals",
          "sect_code": "00000014"
        },
        {
          "sect_name": "ETF",
          "sect_code": "00000069"
        },
        {
          "sect_name": "Fertilizers",
          "sect_code": "00000025"
        },
        {
          "sect_name": "Finance",
          "sect_code": "00000026"
        },
        {
          "sect_name": "FMCG",
          "sect_code": "00000027"
        },
        {
          "sect_name": "Paints/Varnish",
          "sect_code": "00000043"
        },
        {
          "sect_name": "Petrochemicals",
          "sect_code": "00000045"
        },
        {
          "sect_name": "Pharmaceuticals",
          "sect_code": "00000046"
        },
      ];
    },
    reset() {

      localStorage.removeItem('secC');
      this.searchParams = { companyname: "", sectorname: "" };
      this.selComp = null;
      this.selectedSector = { sect_name: "", sect_code: "" };
      this.ddate = "";
      this.pageToLoad = 1;
      this.current_page = 1;
      this.url = this.apiUrl + "/page/" + this.pageToLoad;
      this.fetchData(this.searchParams);
    },
    fetchData(data) {
      if (this.url !== "") {
        console.log("data=====");
        console.log(data);
        console.log("=====data");
        console.log("===== | " + this.url + " | " + this.pageToLoad + " | " + this.current_page + " | " + this.pages + " ========");
        let myself = this;
        // let params = data
        //   ? { companyname: data.companyname, sectorname: data.sectorname }
        //   : {};
        //myself.ddate = new Date(myself.rawData.common_data.date);
        //console.log("=> Date: ", myself.ddate, moment(myself.ddate).format('DD-MM-YYYY'));
        let sDate = myself.ddate == null ? "" : myself.ddate;// !== "" ? moment(myself.ddate).format('DD-MM-YYYY') : "";
        if (this.isFromStockQuery) {
          data.companyname = this.selComp.companyname;
          this.isFromStockQuery = false;
        }
        let paramsInline = data ? `companyname=${(data.companyname).trim()}&sectorname=${(data.sectorname).trim()}&selectdate=${(sDate)}` : "";
        console.log("paramsInline ", paramsInline);

        http.get(this.url + "?" + paramsInline, {}, function (error, response) {
          //  this.axios.post(this.url, params,  {headers: {Authorization: 'Bearer ' + localStorage.getItem('token')}}).then((response) => {
          console.log(response);
          if (!error) {

            const filteredStockHistoryData = response.data.map(function (keyData) {
              let newKeyData = keyData;
              newKeyData.analytics_history = keyData.analytics_history ? keyData.analytics_history : "";
              return newKeyData;
            });

            //console.log("filteredStockHistoryData >>> ", filteredStockHistoryData);
            myself.fillableData = filteredStockHistoryData;
            myself.current_page = myself.pageToLoad;
            myself.totalPages = response.total_pages;
            myself.prevDisabled = myself.pageToLoad == 1;
            myself.nextDisabled = myself.current_page == myself.totalPages;
            myself.isLoading = false;
            // set 5 pages to show
            console.log("current", myself.current_page);
            let i = 5;
            let page = myself.current_page - 2;
            if (page <= 0) page = 1;
            myself.pages = [];
            while (i) {
              myself.pages.push(parseInt(page));
              if (myself.totalPages <= page) break;
              page++;
              i--;
            }
            myself.getSectorData();
            console.log("PAges", myself.pages);
          } else {
            console.log(error);
          }
        });
      } else {
        console.log("=====" + this.url + "========");
      }
    },
    prev() {
      this.pageToLoad = this.current_page - 1;
      this.$router.push({
        query: Object.assign({}, this.$route.query, { page: this.pageToLoad })
      });
      this.fillTable();
    },
    goToPage(page) {
      this.pageToLoad = page;
      this.$router.push({
        query: Object.assign({}, this.$route.query, { page: this.pageToLoad })
      });
      this.fillTable();
    },
    next() {
      console.log(this.$route.query);
      this.pageToLoad = this.current_page + 1;
      this.$router.push({
        query: Object.assign({}, this.$route.query, { page: this.pageToLoad })
      });
      this.fillTable();
    },
    fillTable() {
      let url = this.apiUrl; //+"?a=1"
      if (this.pageToLoad != this.current_page) url += "/page/" + this.pageToLoad;
      this.url = url;
      this.fetchData(this.searchParams);
    },
    remove(index) {
      this.fillableData.splice(index, 1);
    }
  }
};
</script>
<style>
.table td {
  padding: 5px 10px 5px 10px;
}

.history-col {
  /*white-space: pre-line;*/
}

.company-wrapper {
  display: flex;
  justify-content: start;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
}

.company-chidl1 {
  width: 50%;
}

.company-chidl2 {
  width: 100%;
}

.form-control[readonly] {
  background-color: unset;
}

/* .v-select .dropdown-toggle{
  height: 38px !important;
} */

.dropdown-toggle {
  height: 38px !important;
}

.cron-query-content {
  display: grid;
  overflow-y: scroll;
  height: 580px;
}

.sector-query-content {
  /* display: grid; */
  overflow-y: scroll;
  align-content: start;
  height: 560px;
}

.n-lbl {
  background: #fdffed;
  padding: 0 5px 0 5px;
  border-radius: 7px;
}

.text-small {
  font-size: small;
}
</style>


// WEBPACK FOOTER //
// src/views/reports/stock-history.vue